export default __webpack_public_path__ + "static/media/splash02.45fc581f.png";